export default {
  任务中心: "任务中心",
  消息提醒: "消息提醒",
  "拜访&审计日程": "拜访&审计日程",
  VCR任务: "VCR任务",
  供应商资质到期预警: "供应商资质到期预警",
  合同到期预警: "合同到期预警",
  "近6个月采购订单数量/金额趋势": "近6个月采购订单数量/金额趋势",
  剩余: "剩余",
  天: "天",
  序号: "序号",
  任务标题: "任务标题",
  任务状态: "任务状态",
  全部: "全部",
  待办: "待办",
  已办: "已办",
  单据类型: "单据类型",
  发起人: "发起人",
  发起部门: "发起部门",
  接收时间: "接收时间",
  进行中: "进行中",
  生产物料: "生产物料",
  非生产物料: "非生产物料",
  快捷应用: "快捷应用",
  代供应商注册: "代供应商注册",
  发起供应商评估: "发起供应商评估",
  创建准入申请: "创建准入申请",
  创建价格申请: "创建价格申请",
  发起询价: "发起询价",
  建立合同: "建立合同",
  查看更多: "查看更多",
  未处理: "未处理",
  已询价: "已询价",
  已转PO: "已转PO",
  已到货: "已收货",
  已付款: "已付款",
  待开始: "待开始",
  物料质量标准已确定: "物料质量标准已确定",
  供应商开发与筛选已完成: "供应商开发与筛选已完成",
  供应商选择与评估已完成: "供应商选择与评估已完成",
  样品小试或中试研究已完成: "样品小试或中试研究已完成",
  "供应商合格认证已完成（原供应商准入）":
    "供应商合格认证已完成（原供应商准入）",
  采购任务: "采购任务",
  寻源任务: "寻源任务",
  我收到的: "我收到的",
  我发起的: "我发起的",
  供应商名称: "供应商名称",
  发起时间: "发起时间",
  流程用时: "流程用时",
  小时: "小时",
  分钟: "分钟",
  已结束: "已结束",
  未读: "未读",
  已读: "已读",
  消息提醒列表: "消息提醒列表",
  消息状态: "消息状态",
};
